module.exports = __webpack_public_path__ + "media/135.0330f797.wav";